import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { IProps, IState } from './types';
import { GameChkqualifyResp } from 'bff/models/game/gameChkqualify';
import { setGameQualifyModalVisibleAction } from 'redux/actions/modal.action';
import { GamePOI } from 'constants/enums/gamePOI.enum';
import gameService from 'bff/services/gameService';
import { RootReducersState } from 'redux/reducers';
import { SysOption } from 'bff/models/info';

class SignupComplete extends React.Component<IProps, IState> {
  state:IState = {
    timeoutID: null
  }

  async componentDidMount () {
    const args = {
      GAMEPOI: GamePOI.REG
    };
    const response = await gameService.gameChkqualify(args);
    if (response && response.QUALIFIED_DCNT > 0) {
      // 顯示抽獎資格提示跳窗
      this.props.setGameQualifyModalVisible(true, GamePOI.REG, response);
    }
    // this.handleExpiredTimer(6);
  }

  componentWillUnmount () {
    clearTimeout(this.state.timeoutID);
  }

  /**
   * @description 執行倒數計時
   */
  handleExpiredTimer = (second:number) => {
    second -= 1;

    second = second > 0 ? second : 0;

    /** OTP 驗證碼過期，清除 setTimeOut 事件，更新 State */
    if (second === 0) {
      clearTimeout(this.state.timeoutID);
      this.setState({
        timeoutID: null
      });
      this.props.onGoBack(true);
      return;
    }

    const timeoutId = setTimeout(() => this.handleExpiredTimer(second), 1000);

    this.setState({
      timeoutID: timeoutId
    });
    // // console.log('timeoutId', timeoutId);
  };

  render () {
    const { lineBindingStatus } = this.props;

    /**
   * @description 取得投保完成鈕顯示文字
   */
    const handleGetBtnText = () => {
      if (this.props.originalUrl && this.props.originalUrl.indexOf('/insure-process') !== -1) {
        return '繼續投保';
      }

      return '返回首頁';
    };

    let contentBlock;
    if (lineBindingStatus === '0') {
      contentBlock = (
        <div className="auth-block__row">
          <p className="auth-block__part">註冊完成</p>
          <p className="auth-block__desc" style={{ color: '#FE3208' }}>Line會員綁定成功！</p>
          <p className="auth-block__desc">已為您自動登入</p>
          <p className="auth-block__desc">歡迎使用旺旺友聯網路投保系統</p>
        </div>
      );
    } else if (lineBindingStatus === '1') {
      contentBlock = (
        <div className="auth-block__row">
          <p className="auth-block__part">註冊完成</p>
          <a
            className="auth-block__desc"
            href={this.props.lineReBindingUrl || '#'}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#FE3208' }}
          >
            Line會員綁定失敗！請點此連結重新嘗試綁定。
          </a>
          <p className="auth-block__desc">已為您自動登入</p>
          <p className="auth-block__desc">歡迎使用旺旺友聯網路投保系統</p>
        </div>
      );
    } else {
      contentBlock = (
        <div className="auth-block__row">
          <p className="auth-block__part">註冊完成</p>
          <p className="auth-block__desc">已為您自動登入</p>
          <p className="auth-block__desc">歡迎使用旺旺友聯網路投保系統</p>
        </div>
      );
    }

    const lineBindingButton = !lineBindingStatus ? (
      <span className="element__button element__button--line" onClick={() => { if (this.props.lineBindingUrl) window.open(this.props.lineBindingUrl, '_blank'); }}>LINE綁定</span>
    ) : null;

    return (
      <div className="signup-complete auth-block">
        <div className="auth-block__row">
          <div className="auth-block__complete-icon" />
        </div>
        {contentBlock}
        <div className="auth-block__row signup-complete__controls">
          {lineBindingButton}
          <span className="element__button element__button--red" onClick={() => this.props.onGoBack(false)}>{handleGetBtnText()}</span>
        </div>
      </div>
    );
  }
};

const mapStateToProps = (state: RootReducersState) => ({
  lineBindingUrl: state.system.urlSysOpts.find((opt: SysOption) => opt.PARAM_ID === 'BASE_LINE_BIND')?.PARAM_VALUE || '',
  lineReBindingUrl: state.system.urlSysOpts.find((opt: SysOption) => opt.PARAM_ID === 'BASE_URL_LINE_REBIND')?.PARAM_VALUE || ''
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setGameQualifyModalVisible:
    (visible: boolean, gamePoi: string, checkResult: GameChkqualifyResp) =>
      dispatch(setGameQualifyModalVisibleAction(visible, gamePoi, undefined, checkResult))
});

export default connect(mapStateToProps, mapDispatchToProps)(SignupComplete);
